<template>
  <div>
    <List
      url="subscriber/sre-api/businesss_report_dis/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      :useBatchSuffix="false"
      @edit="edit"
      @deletedata="deletedata"
    >
    <div slot="Filter">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <el-button
              @click="add"
              type="primary"
              icon="el-icon-edit"
              >新增订阅</el-button>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-select
          v-model="searchData.subscriber_name"
          @change="search"
          size="small"
          filterable
          placeholder="请选择订阅者"
          style="width:200px;margin-right:10px;">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="name in subscriberNames"
            :key="name"
            :label="name"
            :value="name">
          </el-option>
        </el-select>

        <el-select
          multiple v-model="selectClouds"
          @visible-change="handleVisibleChangeCloudSearch"
          size="small"
          filterable
          placeholder="请选择云平台（多选）"
          style="width:200px;margin-right:10px;">
          <el-option
            v-for="cloud in cloudEnvList"
            :label="cloud"
            :key="cloud"
            :value="cloud"></el-option>
        </el-select>

        <el-input
          v-model="searchData.dis"
          @change="search"
          size="small"
          style="width:160px;margin-right:10px;"
          placeholder="请输入Dis账号"
        ></el-input>

        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>

      <template v-slot:slot-dis_business_subscription_display="scope">
        <el-tag :type="scope.item.dis_business_subscription ? 'success' : 'danger'">
          {{ scope.item.dis_business_subscription_display }}
        </el-tag>
      </template>

      <template v-slot:slot-subscriber_email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.subscriber_email  }}
        </div>
      </template>

      <template v-slot:slot-subscriber_cc_email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.subscriber_cc_email  }}
        </div>
      </template>

      <template v-slot:slot-subscriber_bc_email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.subscriber_bc_email  }}
        </div>
      </template>

      <template v-slot:slot-dis="scope">
        <div class="cell-wrap-content">
          {{ scope.item.dis }}
        </div>
      </template>
    </List>
    <SubscriberBusinessReportDisUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      :clouds="cloudEnvList"
      :subscriberNames="subscriberNames"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></SubscriberBusinessReportDisUpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import SubscriberBusinessReportDisUpdateBox from "../components/Subscriber/SubscriberBusinessReportDisUpdateBox.vue";

export default {
  components: {
    List,
    SubscriberBusinessReportDisUpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      title: "订阅者",
      selectClouds: [],
      cloudEnvList: [],
      subscriberNames: [],
      tanle: [
        { name: "subscriber_name", label: "订阅人" },
        { name: "subscriber_email", label: "收件邮箱" },
        { name: "subscriber_cc_email", label: "抄送邮箱" },
        { name: "subscriber_bc_email", label: "密件抄送邮箱" },
        { name: "cloud", label: "云平台" },
        { name: "dis", label: "Dis账号" },
        { name: "remark", label: "备注" },
      ],
      searchData: {
        subscriber_name: "",
        cloud: "",
        dis: "",
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
    this.fetchSubscriberNames();
  },
  methods: {
    dealList(data) {
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateForm = {
        dis_business_subscription: "是",
        subscriber_name: localStorage.getItem('user_name'),
        subscriber_email: localStorage.getItem('email')
      };
      this.updateType = "add";
      this.updateBlock = true;
    },
    search() {
      this.searchData.cloud = this.selectClouds.join(",");
      this.updateList++;
    },
    handleVisibleChangeCloudSearch(visible) {
      if (!visible) {  // 只在下拉框隐藏时触发搜索
        this.search();
      }
    },
    deletedata(val) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "subscriber/sre-api/businesss_report_dis/" + val.id + "/";
        this.$http["delete"](url,
          () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          },
          () => {
            this.$message({message: "删除失败", type: "error"});
          }
        );
      }).catch(() => {
        this.$message({message: "已取消删除", type: "warning"});
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    },
    fetchSubscriberNames() {
      this.$http["get"](
        "subscriber/subscriber/", {}, (data) => {
          if (data && data.data && data.data.results) {
            this.subscriberNames = data.data.results.map(item => item.name);
          }
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
/* 标签样式 */
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

/* 布局样式 */
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

/* 表格样式, 全局左对齐 */
// /deep/ .cell {
//   text-align: left !important;  // 单元格内容左对齐
// }

/* dis 字段样式 */
.cell-wrap-content {
  white-space: pre-line;  // 换行后内容对齐
  word-break: break-word;
  max-width: 300px;
  padding: 8px 0;
  display: block;
  margin: 0;
}

/* 针对特定字段的单元格左对齐 */
/deep/ .el-table__row {
  td:nth-child(2) .cell,
  td:nth-child(3) .cell,
  td:nth-child(4) .cell,
  td:nth-child(5) .cell,
  td:nth-child(6) .cell,
  td:nth-child(7) .cell,
  td:nth-child(8) .cell
  {
    text-align: left !important;
  }
}
</style>
